import React from 'react';
import { Typography, Button, Tooltip } from '@material-ui/core';
import useLocales from 'hooks/useLocales';

interface ActionButtonProps {
  label: string;
  onClick: (e?: React.MouseEvent<HTMLButtonElement>) => void;
  isDisabled?: boolean;
  backgroundColor: string;
  ariaLabel?: string;
  tooltip?: string;
  tooltipPlacement?:
    | 'bottom'
    | 'left'
    | 'right'
    | 'top'
    | 'bottom-end'
    | 'bottom-start'
    | 'left-end'
    | 'left-start'
    | 'right-end'
    | 'right-start'
    | 'top-end'
    | 'top-start';
}

export const DynamicActionButton: React.FC<ActionButtonProps> = ({
  label,
  onClick,
  isDisabled,
  backgroundColor,
  ariaLabel,
  tooltip,
  tooltipPlacement = 'top'
}) => {
  const { t } = useLocales();

  const buttonElement = (
    <Button
      onClick={onClick}
      aria-label={
        ariaLabel
          ? t(ariaLabel) || ariaLabel
          : label.toLowerCase().replace(/\s+/g, '-')
      }
      size="large"
      disabled={isDisabled}
      sx={{
        backgroundColor: isDisabled ? '#E0E0E0' : backgroundColor,
        minWidth: '88px',
        maxHeight: '36px'
      }}
    >
      <Typography variant="caption" color="white">
        {t(label) || label}
      </Typography>
    </Button>
  );

  // Only render tooltip if tooltip prop is provided and not empty
  if (tooltip && tooltip.trim() !== '') {
    return (
      <Tooltip title={t(tooltip) || tooltip} placement={tooltipPlacement} arrow>
        <span style={{ display: 'inline-block' }}>{buttonElement}</span>
      </Tooltip>
    );
  }

  return buttonElement;
};
